import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { addFollowrs, getAllDirectory, getAllCategories, getTeamMembers, getBookedSelService, getCatsById, getDirBusinessTypes, getDirectories, getDirectory, getFollowersData, getServices, getUsersData, getUsersFollowers, getUsersFollowing, practiceFollowers, practiceFollowing, professinalFollowing, professionalFollowers, removeFollwers, supplierFollowers, supplierFollowing, getUsersDataPending, addFollowingDataMutation, getFollowingData, updateFollowingDataMutation, deleteFollowingDataMutation, getUserDataStatus, getDirectoryFollowersData, GET_DIRECTORY_BY_ID } from '../queries/detailsPage.query';
import { ToastService } from 'src/app/core/toast.service';

@Injectable({
  providedIn: 'root'
})
export class DirDetailsService {
  getUsersFollowing(id: any) {
    throw new Error('Method not implemented.');
  }

  constructor(private apollo: Apollo, private toast: ToastService) { }

  getDirectorybyId(id: string) {

    return this.apollo.use("external").subscribe({
      query: getDirectory,
      variables: { id }
    }).pipe(pluck('data', 'directories_by_pk'));

  }

  removeUser(id) {

    return this.apollo.use("external").subscribe({
      query: removeFollwers,
      variables: { id }
    }).pipe(pluck('data', 'delete_directory_followers'));

  }

  /*getAllDirCats(){
    return this.apollo.use("external").subscribe({
      query : getAllCategories
    }).pipe(pluck('data', 'directory_categories'));

  }*/

  getAllDirectory(limit: number, offset: number, search?: string) {
    let where = {};

    if (search?.trim()) {
      const likeSearch = `%${search.trim()}%`;
      where = {
        _or: [
          { company_name: { _ilike: likeSearch } },
          { name: { _ilike: likeSearch } },
          { address: { _ilike: likeSearch } },
          { pincode: { _ilike: likeSearch } }
        ]
      };
    }

    return this.apollo.use("external").watchQuery({
      query: getAllDirectory,
      variables: {
        limit,
        offset,
        where
      },
    }).valueChanges.pipe(pluck('data', 'directories'));
  }






  getAllDirBusTYpes() {
    return this.apollo.use("external").subscribe({
      query: getDirBusinessTypes
    }).pipe(pluck('data', 'directory_business_types'));

  }

  getDirCatsByBusId(id: string) {

    return this.apollo.use("external").subscribe({
      query: getCatsById,
      variables: { id }
    }).pipe(pluck('data', 'directory_categories'));

  }

  getServices(id: string) {


    return this.apollo.use("external").subscribe({
      query: getServices,
      variables: { id }
    }).pipe(pluck('data', 'directory_appointment_slots'));

  }

  getTeamMembers(id: string) {


    return this.apollo.use("external").subscribe({
      query: getTeamMembers,
      variables: { id }
    }).pipe(pluck('data', 'directory_team_members'));

  }
  getBookesAppt(id: string) {


    return this.apollo.use("external").subscribe({
      query: getBookedSelService,
      variables: { id }
    }).pipe(pluck('data', 'directory_appointments'));

  }
  getBookesApptByMember(id: string) {

  }

  getDirectoriesData(id: string, limit: number, offset: number, searchText?: string) {
    let where: any = {
      directory_category_id: { _eq: id }
    };

    if (searchText?.trim()) {
      const like = `%${searchText.trim()}%`;
      where._or = [
        { company_name: { _ilike: like } },
        { name: { _ilike: like } },
        { address: { _ilike: like } },
        { pincode: { _ilike: like } }
      ];
    }

    return this.apollo.use("external").watchQuery({
      query: getDirectories,
      variables: { limit, offset, where }
    }).valueChanges.pipe(pluck('data', 'directories'));
  }





  async addFollwers(follow): Promise<any> {

    try {

      await this.apollo.use("external").mutate({
        mutation: addFollowrs,
        variables: { followObj: follow }
      }).pipe(pluck('data', 'insert_directory_followers_one')).toPromise();

      this.toast.openSnackBar(
        'you followed succesfully'
      );
      return true;

    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('You Failed To follow');
      return false;

    }

  }

  getPracticeFollowing(id: string) {

    return this.apollo.use("external").subscribe({
      query: practiceFollowing,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }


  getSupplierFollowing(id: string) {

    return this.apollo.use("external").subscribe({
      query: supplierFollowing,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }



  getProfessionalFollowing(id: string) {

    return this.apollo.use("external").subscribe({
      query: professinalFollowing,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }

  getSupplierFollowers(id: string) {

    return this.apollo.use("external").subscribe({
      query: supplierFollowers,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }

  getProfessionalFollowers(id: string) {

    return this.apollo.use("external").subscribe({
      query: professionalFollowers,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }
  getUserDataStatus(userId: string) {
    return this.apollo.use("external").subscribe({
      query: getUserDataStatus,
      variables: { userId }
    }).pipe(pluck('data', 'directory_followers'));
  }



  getFollowersData(tagIdArray) {

    return this.apollo.subscribe({
      query: getFollowersData,
      variables: { tagIdArray }
    }).pipe(pluck('data', 'clients'));

  }

  getPracticeFollowers(id: string) {

    return this.apollo.use("external").subscribe({
      query: practiceFollowers,
      variables: { id }
    }).pipe(pluck('data', 'directory_followers'));

  }


  getUsersCount(userId: string) {


    return this.apollo.subscribe({
      query: getUsersData,
      variables: { userId }
    }).pipe(pluck('data'));

  }


  getUsersCountPending(userId: string) {


    return this.apollo.subscribe({
      query: getUsersDataPending,
      variables: { userId }
    }).pipe(pluck('data'));

  }

  getUsersDetailsFollowing(userId: string) {

    return this.apollo.subscribe({
      query: getUsersFollowing,
      variables: { userId }
    }).pipe(pluck('data', 'who_is_following'));

  }

  getDirectoryFollowers() {
    return this.apollo.use("external").watchQuery({
      query: getDirectoryFollowersData
    }).valueChanges.pipe(pluck('data', 'directory_followers'));
  }


  getUsersDetailsFollowers(userId: string) {

    return this.apollo.subscribe({
      query: getUsersFollowers,
      variables: { userId }
    }).pipe(pluck('data', 'to_whome_i_am_following'));
  }

  addFollowerData(follow: any): Promise<any> {

    return this.apollo.mutate({
      mutation: addFollowingDataMutation,
      variables: {
        object: follow
      }
    }).toPromise();
  }

  getFollowingList(userId: string): Observable<{ following_user_id: string }[]> {
    return this.apollo.subscribe({
      query: getFollowingData,
      variables: { userId }
    }).pipe(pluck('data', 'user_following'));
  }

  updateFollowStatus(requestId: string, newStatus: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateFollowingDataMutation,
        variables: {
          id: requestId,
          status: newStatus,
        },
      })
      .toPromise()

  }
  deleteFollowStatus(requestId: string,): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteFollowingDataMutation,
        variables: {
          id: requestId,

        },
      })
      .toPromise()

  }
  /** Fetch a single directory record by its UUID */
  getDirectoryPreloginByid(id: string): Observable<any> {
    return this.apollo
      .query({
        query: GET_DIRECTORY_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only', // always hit server
      })
      .pipe(map((result: any) => result.data.directories[0]));
  }


}